import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconFuelConsumption = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M20 10.5C20 11.33 19.33 12 18.5 12C17.67 12 17 11.33 17 10.5C17 9.67 18.5 7.5 18.5 7.5C18.5 7.5 20 9.67 20 10.5Z" }),
            React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M18.77 4.38005L17.97 2.55005L10.04 6.02005C9.07 6.45005 8.31 7.24005 7.92 8.23005L4.37 17.32L5.3 17.68L4 21H6.15L7.16 18.41L8.09 18.7701L11.22 17.4C11.71 17.19 12.09 16.79 12.28 16.3L14.16 11.48L12.29 7.21005L18.77 4.37005V4.38005ZM10.48 15.41L7.89 16.54L10.08 10.95L11.94 11.68L10.48 15.41Z" }),
            ' ')));
};
